<template>
  <footer class="footer" :class="{black: isBlack}">
    <div class="footer_links">
      <a target="_blank" class="link" href="https://www.tencentmusic.com/">腾讯音乐</a>
      <span class="divide">|</span>
      <router-link :to="{name: 'guidePage'}" class="link">帮助中心</router-link>
    </div>
    <p class="text">Copyright © 1998 - {{ new Date().getFullYear() }} Tencent. <a target="_blank" rel="noopener noreferrer" href="http://www.tencent.com/en-us/le/copyrightstatement.shtml" title="All Rights Reserved.">All Rights Reserved.</a></p>
    <p class="text">腾讯音乐娱乐科技（深圳）有限公司 <a target="_blank" rel="noopener noreferrer" href="http://www.tencent.com/en-us/le/copyrightstatement.shtml" title="All Rights Reserved.">版权所有</a></p>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
    }
  },
  computed: {
    isBlack() {
      return ['/index', '/ai_publish/index', '/not_registry'].includes(this.$route.path)
    }
  }
}
</script>

<style lang="scss">

.footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 122px;
  padding: 32px 0 16px;
  background-color: #f7f7f7;
  text-align: center;

  box-shadow: 0 0 18px 1px #eee;

  &.black {
    background: linear-gradient(#001e60 70%, #00258b 100%);
    box-shadow: none;

    .divide {
      color: #fff;
    }

    .link {
      color: #fff;
    }
  }

  .footer_links {
    margin: 0 0 24px 0;

  }
  .divide {
      margin: 0 8px;
      border: none;
      color: rgba(0, 0, 0, .65);
    }
  .link {
    color: rgba(0, 0, 0, .65);
  }

  .text {
    color: #999;
  }
}
</style>
